<template>
    <aside class="settings-content settings-account">
        <Loading v-if="is_loading" />
        <Scrollbar class="data-list" :show_bar="true">
            <div class="alert" v-show="is_form_error"><svg-icon name="user-circle-gear" />Complete your profile</div>
            <div class="main">

                <Transition name="fade" v-show="is_show_cropper">
                    <div class="logo-cropper-wrap" v-if="current_index !== -1">

                        <div class="cropper-box">
                            <header>
                                <i @click="is_show_alert_modal = true"><svg-icon name="close" /></i>
                            </header>
                            <div class="box">
                                <cropper ref="cropper" image-restriction="stencil" :stencil-size="stencilSize"
                                    :default-size="defaultSize" @change="onChange" :stencil-props="{
                                        lines: {},
                                        handlers: {},
                                        movable: false,
                                        scalable: false,
                                        aspectRatio: 1,
                                    }" :debounce="false" :transitions="false" :canvas="{
                                        width: 600,
                                        height: 600,
                                    }" :min-width="150" :min-height="150" :src="image.src" />


                            </div>
                            <footer>
                                <div class="control">
                                    <div class="slider">
                                        <span>Zoom</span>
                                        <Slider :zoom="zoom" @change="onZoom" />
                                    </div>


                                    <div class="rotate">
                                        <span>Rotate</span>
                                        <i @click="rotate(-90)"><svg-icon name="rotate" /></i>
                                        <i @click="rotate(90)"><svg-icon name="rotate-right" /></i>
                                    </div>
                                </div>

                                <div class="btns">
                                    <el-button :key="'border'" @click="upload()">Change image</el-button>
                                    <el-button type="primary" @click="crop">Save</el-button>
                                </div>


                            </footer>

                        </div>

                    </div>
                </Transition>

                <!-- content -->
                <div class="content" v-if="$store.state.user_data">
                    <div class="title">Your Account</div>
                    <!-- <div class="small-label small-label-text">{{ $store.state.user_data.email }} - <span>Verified</span></div> -->
                    <div class="small-label small-label-text">{{ $store.state.user_data.email }}</div>
                    <Form :schema="schema" @submit="submit" :values="user_data" v-slot="{ errors, success }"
                        class="user-form-wrap" :class="{ 'is-error': is_error }" ref="form" :key="key_refrash"
                        :need_error="true">
                        <div class="sign-date">
                            <p><span>{{ role_name }} </span> Registered: {{
                                $filters.momentFormat($store.state.user_data.created_at, 'MMM DD, YYYY') }}
                            </p>
                        </div>

                        <div class="small-title">Your Information</div>
                        <div class="flex-box">
                            <div class="left">
                                <figure class="avatar">
                                    <input class="avatar-input" type="file" ref="file" @change="loadImage($event)"
                                        accept="image/*">
                                    <img v-if="$store.state.user_data.avatar" :src="$store.state.user_data.avatar" />
                                    <img v-else :src="require('@/assets/images/user.png')" />
                                    <i>
                                        <SvgIcon name="pen" />
                                    </i>
                                </figure>
                            </div>

                            <div class="right">
                                <div class="item-box">
                                    <div class="item">
                                        <label class="label">First name</label>
                                        <Field type="text" k="first_name" placeholder="First name"
                                            :default_value="user_data.first_name" :error_msg="errors.first_name"
                                            :is_success="success.first_name" @update="update"
                                            :ref="(el) => { els.push(el) }" />
                                    </div>
                                    <div class="item">
                                        <label class="label">Last name</label>
                                        <Field type="text" k="last_name" placeholder="Last name"
                                            :default_value="user_data.last_name" :error_msg="errors.last_name"
                                            :is_success="success.last_name" @update="update"
                                            :ref="(el) => { els.push(el) }" />
                                    </div>
                                </div>
                                <div class="item-box" v-if="$store.state.user_data.merchant_account !== null">

                                </div>

                                <Button class="save-btn btn-padding" type="submit" color="dark-blue"
                                    size="32" :border_r="6">Save</Button>
                            </div>

                        </div>
                    </Form>
                    <div class="small-title">Login & Security</div>
                    <AccountEmail v-if="$store.state.user_data.email" :email="$store.state.user_data.email"
                        :edit_email="edit_email" :key="edit_email" @handleChangeEmail="handleChangeEmail" />
                    <Security :key="security_refrash" @refrash="refrashSecurity" />
                </div>

                <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
                    <div class="box">
                        <header class="delete-header">Discard changes</header>
                        <p>Are you sure you want to discard changes you made?</p>
                        <div class="btns">
                            <el-button text @click.native="is_show_alert_modal = false;">Cancel</el-button>
                            <el-button type="primary"
                                @click.native="is_show_alert_modal = false; is_show_cropper = false;">Yes</el-button>
                        </div>
                    </div>
                </Modal>
            </div>
        </Scrollbar>
    </aside>
</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import AccountEmail from '@/components/settings/YourAccount/AccountEmail.vue';
import Loading from '@/components/ui/Loading.vue';
import * as yup from 'yup';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import CheckArray from '@/utils/CheckArray';
import getMimeType from '@/utils/getMimeType';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Security from '@/components/settings/YourAccount/SecurityTemplate.vue';
import Slider from '@/components/settings/Slider.vue';
import Modal from '@/components/ui/Modal.vue';
import { ElButton } from 'element-plus';

export default {
    name: 'Account',

    components: {
        Field,
        Form,
        Button,
        Dropdown,
        AccountEmail,
        Loading,
        Cropper,
        SvgIcon,
        Scrollbar,
        Security,
        Slider,
        Modal,
        ElButton
    },

    props: {
    },

    data() {
        return {
            is_loading: true,
            user_data: {
                portal_user_id: '',
                department_id: '',
                first_name: '',
                last_name: '',
                company_id: 0,
            },
            edit_email: false,
            edit_role: false,
            els: [],
            schema: yup.object().shape({
                first_name: yup.string().required('The first name can’t leave as blank'),
                last_name: yup.string().required('The last name can’t leave as blank'),
                // company_name: yup.string().required('The company can’t leave as blank'),
            }),
            is_error: false,
            is_form_error: false,
            key_refrash: 0,
            //avatar handle
            is_show_cropper: false,
            image: {
                src: null,
                type: null
            },
            img_blob: null,
            zoom: 0,
            is_show_alert_modal: false,
            security_refrash: 0,
            companys: [],
        }
    },

    computed: {
        company_index() {
            let find_index = this.companys.findIndex(item => item.id === this.user_data.company_id);
            return find_index !== -1 ? find_index : 0;
        },

        //this.user_data.department_id is "not" the index...
        department_index() {
            let find_index = this.$store.state.department_select.findIndex(item => item.id === this.user_data.department_id);
            return find_index !== -1 ? find_index : 0;
        },

        role_name() {
            let role = this.$store.state.user_data?.permission_list?.role_name;
            return role ? role.charAt(0).toUpperCase() + role.slice(1) : '';
        },

    },

    methods: {
        async start() {
            if (this.$store.state.user_data) {
                let department = CheckArray(this.$store.state.user_data.departments);
                // let company = CheckArray(this.$store.state.user_data.companies);

                this.user_data = {
                    portal_user_id: this.$store.state.user_data.id,
                    department_id: department ? department[0].pivot.department_id : null,
                    first_name: this.$store.state.user_data.first_name,
                    last_name: this.$store.state.user_data.last_name,
                    company_id: 0,
                    // company_name: company ? company[0].clean_name : ''
                };

                this.temp_email = this.$store.state.user_data.email,
                    this.temp_avatar = this.$store.state.user_data.avatar;

                setTimeout(() => {
                    this.els.forEach(el => {
                        if (el) el.sync();
                    });

                }, 100);

                this.$ajax.get('/settings/get-company-list').then(res => {
                    this.is_loading = false;
                    this.companys = [];
                    
                    res.data.data.forEach(item => {
                        item.text = item.name;
                        this.companys.push(item);
                    });
                    this.user_data.company_id = this.companys[0]?.id;
                });

                this.key_refrash += 1;
            }

        },

        crop() {
            this.is_loading = true;
            const { canvas } = this.$refs.cropper.getResult();
            canvas.toBlob((blob) => {
                this.img_blob = blob;
                this.$store.state.user_data.avatar = URL.createObjectURL(blob)
                this.submitChangeAvatar();
                this.is_show_cropper = false;
            }, this.image.type);

        },

        loadImage(event) {
            // Reference to the DOM input element
            const { files } = event.target;
            // Ensure that you have a file before attempting to read it
            if (files && files[0]) {
                // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
                if (this.image.src) {
                    URL.revokeObjectURL(this.image.src)
                }
                // 2. Create the blob link to the file to optimize performance:
                const blob = URL.createObjectURL(files[0]);

                // Create a new FileReader to read this image binary data
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.image = {
                        src: blob,
                        type: getMimeType(e.target.result, files[0].type),
                    };
                };
                reader.readAsArrayBuffer(files[0]);

                this.is_show_cropper = true;
            }
        },

        //image function
        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },

        stencilSize({ boundaries }) {

            return {
                width: Math.min(boundaries.height, boundaries.width) - 48,
                height: Math.min(boundaries.height, boundaries.width) - 48,
            };
        },

        onChange(result) {
            const cropper = this.$refs.cropper;
            if (cropper) {
                const { coordinates, imageSize } = cropper;

                if (
                    imageSize.width / imageSize.height >
                    coordinates.width / coordinates.height
                ) {
                    // Determine the position of slider bullet
                    // It's 0 if the stencil has the maximum size and it's 1 if the has the minimum size
                    this.zoom =
                        (cropper.imageSize.height - cropper.coordinates.height) /
                        (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
                } else {
                    this.zoom =
                        (cropper.imageSize.width - cropper.coordinates.width) /
                        (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
                }
            }
        },

        rotate(angle) {
            this.$refs.cropper.rotate(angle);
        },

        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },

        stencilSize({ boundaries }) {
            return {
                width: Math.min(boundaries.height, boundaries.width),
                height: Math.min(boundaries.height, boundaries.width),
            };
        },


        onZoom(value) {
            const cropper = this.$refs.cropper;
            if (cropper) {
                // console.log('onZoom => ' + value);
                // cropper.zoom(Number(1));
                if (cropper.imageSize.height < cropper.imageSize.width) {
                    const minHeight = cropper.sizeRestrictions.minHeight;
                    const imageHeight = cropper.imageSize.height;
                    // Determine the current absolute zoom and the new absolute zoom
                    // to calculate the sought relative zoom value
                    cropper.zoom(
                        (imageHeight - this.zoom * (imageHeight - minHeight)) /
                        (imageHeight - value * (imageHeight - minHeight))
                    );
                } else {
                    const minWidth = cropper.sizeRestrictions.minWidth;
                    const imageWidth = cropper.imageSize.width;
                    cropper.zoom(
                        (imageWidth - this.zoom * (imageWidth - minWidth)) /
                        (imageWidth - value * (imageWidth - minWidth))
                    );
                }
            }
        },
        //-----------------------------
        upload() {
            this.$refs.file.click();
        },
        update(obj) {
            this.is_error = false;
            this.is_form_error = false;
            this.error_msg = '';

            Object.keys(this.user_data).forEach(key => {
                if (key === obj.key) this.user_data[key] = obj.val;
            });

        },

        updateDrop(val) {
            this.update({ key: 'department_id', val: val.id });
        },

        updateCompany(val) {
            this.user_data.company_id = val.id;
            this.$store.state.user_data.companies[0].id = val.id;
            this.$store.state.user_data.companies[0].name = val.name;
            this.$store.state.user_data.companies[0].clean_name = val.name;
        },

        handleChangeEmail(val) {
            if (this.edit_email) {
                this.edit_email = false;
                //email save success
                if (val && val.email) {
                    this.$store.state.user_data.email = val.email;
                };

            } else {
                this.edit_email = true;
            }
        },

        handleChangeRole(val) {
            if (this.edit_role) {
                this.edit_role = false;
                //role save success
            } else {
                this.edit_role = true;
            }
        },

        submitChangeAvatar() {
            this.is_loading = true;
            let form_data = new FormData();
            form_data.append('avatar', this.img_blob);
            this.$ajax('/settings/login-user-update-avatar', {
                method: 'post',
                data: form_data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                this.is_loading = false;
                this.temp_avatar = this.$store.state.user_data.avatar;
                this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> Avatar updated');
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data) {
                    this.$store.state.user_data.avatar = this.temp_avatar;
                    this.errNofity(err);
                }

            });
        },

        submit(val) {
            if (!val) {
                this.is_form_error = true;
            } else {
                this.is_form_error = false;
                this.edit_email = false;
                this.is_error = false;
                this.is_loading = true;

                this.$ajax('/settings/update-portal-user', {
                    method: 'post',
                    data: this.user_data,
                }).then(res => {
                    this.is_loading = false;

                    if (this.$store.state.user_data.departments) this.$store.state.user_data.departments[0].pivot.department_id = this.user_data.department_id;
                    // if (this.$store.state.user_data.companies){
                    //     this.$store.state.user_data.companies[0].clean_name = this.user_data.company_name;
                    // }else{
                    //     this.$store.state.user_data.companies.push({clean_name:this.user_data.company_name})
                    // }
                    this.$store.state.user_data.first_name = this.user_data.first_name;
                    this.$store.state.user_data.last_name = this.user_data.last_name;
                    this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> Account info updated');

                }).catch(err => {
                    this.is_loading = false;

                    if (err && err.response && err.response.data.data) {
                        // console.log(err.response.data)
                        this.is_error = true;
                        this.error_msg = err.response.data.data.message;
                        this.$refs.form.init();
                    }

                });
            }
        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> Change fail.${mes}`);
        },

        refrashSecurity() {
            this.security_refrash += 1;
            console.log('ok')
        }
    },

    mounted() {

        this.start();
    },
}
</script>
<style lang="scss">
.settings-account {

    .alert {
        font-family: var(--font);
        font-weight: 600;
        font-size: 14px;
        color: var(--dark-blue);
        padding: 8px;
        background: var(--bg-11);
        border-radius: 8px;
        display: flex;
        align-items: center;

        svg {
            width: 24px;
            height: 24px;
            margin-right: 15px;
        }
    }



    .main {
        display: flex;
        margin-top: 30px;


        .content {
            width: -webkit-fill-available;

            .title {
                font-family: var(--font-dm);
                font-size: 48px;
                font-weight: 400;
                line-height: 56px;
                letter-spacing: 1.2%;
                margin-bottom: 8px;
            }

            .sign-date {
                margin: 4px 0;
                font: var(--font-med-14);
                color: var(--dark-blue);
                padding: 0 0 12px 0;
                border-bottom: solid 1px var(--black-40);
                display: flex;
                justify-content: space-between;
                align-items: center;

                span {
                    padding-right: 10px;
                    margin-right: 10px;
                    border-right: solid 1px var(--black-50);
                }

                .ui-button {
                    width: 86px;
                }
            }

            .small-label {
                font: var(--font-demi-14);
                color: var(--neureal);
                display: flex;
                line-height: 18px;
                margin: 12px 0 4px;

                span {
                    margin-left: 6px;
                    flex: 1;
                    color: var(--green);
                    font-family: var(--font);
                    font-size: 12px;
                    font-weight: 400;
                }
            }

            .small-label-text {
                color: var(--black-50);
                font: var(--font-med-12);
                font-family: var(--font);
                line-height: 18px;
                margin: 0;

                a {
                    cursor: pointer;
                    margin-left: 6px;
                    font-weight: 500;
                    font-size: 12px;
                }
            }

            .small-title {
                font: var(--font-demi-24);
                font-weight: 400;
                margin: 24px 0 12px;
            }



            .ui-dropdown {
                margin: 16px 0;

                .ui-button {
                    // padding: 11px 8px !important;
                    border: 1px solid var(--black-20);
                    border-radius: 6px;
                    color: var(--black-90);
                    font-weight: 500;
                    font-family: var(--font);
                    width: unset;
                    height: 39px;
                    justify-content: unset;
                    line-height: unset;

                    span {
                        flex: 1;
                        font: unset;
                    }

                }

                .item-box {
                    display: unset;
                    width: 100%;

                    .item {
                        width: unset;

                        &:first-child {
                            margin-right: 0px;
                        }
                    }
                }
            }

        }

        .user-form-wrap {
            .flex-box {
                display: flex;

                .left {
                    .avatar {
                        height: 100px;
                        width: 100px;
                        background-color: var(--black-20);
                        //overflow: hidden;
                        border-radius: 50%;
                        position: relative;
                        cursor: pointer;

                        img {
                            height: 100%;
                            width: 100%;
                            display: block;
                            object-fit: contain;
                            border-radius: 50%;
                        }

                        i {
                            position: absolute;
                            height: 24px;
                            width: 24px;
                            border-radius: 50%;
                            border: solid 1px var(--dark-blue);
                            background: white;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            right: 0;
                            bottom: 0;

                            svg {
                                height: 12px;
                                width: 12px;
                                position: relative;
                                fill: var(--dark-blue);
                            }
                        }

                    }
                }

                .right {
                    margin-left: 32px;
                    width: calc(100% - 100px);

                    .save-btn {
                        float: right;
                    }
                }

            }

            .item-box {
                display: flex;

                .item {
                    width: calc((100% - 12px) / 2);

                    &:first-child {
                        margin-right: 16px;
                    }

                    .ui-input,
                    .ui-dropdown {
                        margin-top: 4px;
                    }
                }
            }

            .label {
                font: var(--font-med-12);
                color: var(--black-90);

                &:after {
                    content: ' *';
                    color: var(--alert);
                }
            }

            input {
                padding: 11px 8px;
            }

            .alert-text {
                margin: 12px 0 0;
                padding: 8px;
                font-size: 12px;
                color: var(--black-90);
                background-color: var(--bg-07);
            }



            &.is-error {

                .ui-input .ui-input--wrap select,
                .ui-input .ui-input--wrap input,
                .ui-input .ui-input--select select,
                .ui-input .ui-input--select input,
                .ui-input .ui-input--icon-wrap {
                    border-color: var(--alert) !important;
                }

                .error-msg {
                    margin: 4px 0 0;
                    font-size: 12px;
                    color: var(--alert);

                    &::before {
                        content: '*';
                    }
                }
            }
        }
    }

    .avatar-input {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        opacity: 0;
        top: 0;
        z-index: 3;
        cursor: pointer;
    }

    .ui-button {

        &.btn-padding {
            padding: 8px 24px;
            height: initial;
            border-radius: 100px;
            line-height: initial;
        }

    }

    .cropper-wrap {
        position: fixed;
        z-index: 999;
        height: 100%;
        left: 0;
        top: 0;
        width: 100%;
        background-color: rgba(#fff, .5);
        backdrop-filter: blur(5px);

        i {
            cursor: pointer;
            height: 42px;
            width: 42px;
            position: absolute;
            z-index: 3;
            right: 24px;
            top: 24px;

            svg {
                display: block;
                height: 100%;
                width: 100%;
                fill: var(--dark-blue);
            }
        }

        .box {
            width: 500px;
            max-height: 80vh;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            .ui-button {
                width: 80px;
                display: block;
                text-align: center;
                margin: 12px auto 0;
            }
        }
    }

    .cropper-box {
        width: 540px;
        background-color: white;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-shadow: var(--bot-4dp);
        border-radius: 16px;

        header {
            padding: 12px 18px;
            display: flex;
            align-items: center;

            h2 {
                flex: 1;
                font-size: 20px;
                font-family: var(--font-med);
                color: var(--neureal);
            }
        }

        footer {
            padding: 18px;

            .control {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 16px;

                span {
                    padding-right: 5px;
                    color: var(--dark-blue);
                }

                .slider {
                    display: flex;
                    align-items: center;
                    width: 240px;
                    margin: 0 12px;

                    i {
                        height: 24px;
                        width: 24px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 3px;

                        svg {
                            height: 18px;
                            width: 18px;
                            position: relative;
                            fill: var(--dark-blue);
                        }
                    }
                }

                .rotate {
                    display: flex;
                    align-items: center;
                    margin: 0 12px;

                    i {
                        height: 24px;
                        width: 24px;
                        border: 1px solid var(--dark-blue);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 6px;

                        svg {
                            height: 14px;
                            width: 14px;
                            position: relative;
                            fill: var(--dark-blue);
                        }
                    }
                }

                .vue3-slider .handle {
                    height: 11px !important;
                    width: 11px !important;
                    transform: scale(1) !important;
                    margin-top: -5px;
                    margin-left: -5px;
                    border-radius: 50%;
                    background-color: var('');
                }
            }

            .text {
                color: var(--black-60);
                margin: 20px 0 10px;
            }

            .btns {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .ui-button {
                margin: 0 6px;
            }

            // .ui-button {
            //     width: 80px;
            //     display: block;
            //     text-align: center;
            //     margin: 12px auto 0;
            // }
        }
    }

}
</style>
